import { Tooltip } from 'antd';
import { Warning } from '@phosphor-icons/react';
import styled from 'styled-components';
import { theme } from '../../utility';

const AlertIcon = styled(Warning)`
  flex: 0 0 auto;
  cursor: help;
`;

const TooltipList = styled.div`
  max-width: 320px;
`;

const TooltipMessage = styled.div`
  &:not(:last-child) {
    margin-bottom: 6px;
  }
`;

export const getTransferAlertMessage = item => {
  const message = item?.alert?.message;
  return typeof message === 'string' && message.trim() ? message : null;
};

export function TransferAlertIndicator({ message, messages, className }) {
  const alertMessages = (messages || [message]).filter(Boolean);

  if (!alertMessages.length) return null;

  const title =
    alertMessages.length === 1 ? (
      alertMessages[0]
    ) : (
      <TooltipList>
        {alertMessages.map(alertMessage => (
          <TooltipMessage key={alertMessage}>{alertMessage}</TooltipMessage>
        ))}
      </TooltipList>
    );

  return (
    <Tooltip title={title}>
      <AlertIcon
        className={className}
        size={16}
        color={theme.colors.orange || theme.colors.yellow}
        weight="fill"
      />
    </Tooltip>
  );
}
